module.exports = __webpack_public_path__ + "img/cic-2024.a9b70dda.jpg";